module.exports = __webpack_public_path__ + "static/media/Corporate_Bond.aaaa30bc.svg";